<div class="container-fluid container-principal" style="height:200vw">

  <div class="row p-4">
    <div class="col-12 d-flex justify-content-center">
      <img src="./../../assets/img/logoSolAgoraV2.webp" alt="Logo Sol Agora" class="navbar-brand">
    </div>
  </div>

  <div class="container pt-3">
    <div class="row pl-3">
      <div class="col-12 d-flex justify-content-center  align-items-center">
        <mat-card class="d-flex justify-content-center  align-items-center flex-column mb-4">
          <mat-card-header>
            <h1 class="titulo-diagonal">Declaração pessoal de saúde</h1>
          </mat-card-header>
          <div class="row pt-2">
            <div class="col-12">
              <mat-stepper [orientation]="'vertical'" [animationDuration]="'0ms'" linear #stepper="matVerticalStepper" (selectionChange)="onStepChange($event)" #step>
                <ng-template matStepperIcon="edit">
                  <mat-icon *ngIf="stepper.selectedIndex === stepper._getFocusIndex() || finalizado == true">check</mat-icon>
                </ng-template>
                <form [formGroup]="dpsForm">
                    <mat-step label="1ª Pergunta: Você está ou esteve afastado nos últimos 3 anos por mais de 45 dias em decorrência de doença/acidente?" [completed]="dpsForm.get('questionAnswer1')?.valid">
                      <div class="row">
                        <div class="col-12">
                            <!-- Questão 1 -->
                            <input type="radio" id="afastamento_nao" formControlName="questionAnswer1" value="não" class="me-2">
                            <label for="afastamento_nao" class="mb-0 p-1">Não</label>
                        </div>
                        <div class="col-12">
                          <input type="radio" id="afastamento_sim" formControlName="questionAnswer1" value="sim" class="me-2">
                          <label for="afastamento_sim" class="mb-0 p-1">Sim</label>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                      </div>
                    </div>
                    </mat-step>
                  <mat-step label="2ª Pergunta: Você tem Hipertensão Arterial (pressão alta)?" [completed]="dpsForm.get('questionAnswer2')?.valid">
                    <div class="row">
                        <div class="col-12">
                          <input type="radio" id="hipertensao_nao" value="não" formControlName="questionAnswer2" class="me-2">
                          <label for="hipertensao_nao" class="mb-0 p-1">Não</label>
                        </div>
                        <div class="col-12 d-flex">
                          <input type="radio" id="hipertensao_sim" value="Sim, com complicações ou problemas decorrentes da Hipertensão" formControlName="questionAnswer2" class="me-2">
                          <label for="hipertensao_sim" class="mb-0 p-1">Sim, com complicações ou problemas decorrentes da Hipertensão</label>
                        </div>

                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step label="3ª Pergunta: Você tem Diabetes?" [completed]="dpsForm.get('questionAnswer3')?.valid">
                    <div class="row">
                        <!-- Questão 3 -->
                        <div class="col-12  d-flex">
                            <input type="radio" id="diabetes_nao" value="não" formControlName="questionAnswer3" class="me-2">
                            <label for="diabetes_nao" class="mb-0 p-1">Não</label>
                        </div>
                        <div class="col-12  d-flex">
                            <input type="radio" id="diabetes_sim" value="Sim, com alteração de sensibilidade (neuropatia), problema renal ou de visão" formControlName="questionAnswer3" class="me-2">
                            <label for="diabetes_sim" class="mb-0 p-1">Sim, com alteração de sensibilidade (neuropatia), problema renal ou de visão</label>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step label="4ª Pergunta: Você foi diagnosticado ou faz tratamento clínico para as seguintes doenças?" [completed]="dpsForm.get('questionAnswer4')?.valid">
                    <div class="row">
                        <!-- Questão 4 -->
                      <div class="col-12  d-flex" *ngFor="let option of questionAnswer4List">
                        <mat-checkbox class="mb-0 p-1"
                            (change)="onCheckboxChange('questionAnswer4', option, $event)"
                            [checked]="dpsForm.get('questionAnswer4')?.value?.includes(option)">
                            {{ option }}
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 d-flex justify-content-center">
                        <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step label="5ª Pergunta: Nos últimos 5 anos, você foi diagnosticado ou tratado clinicamente para Doença Neoplásica Malígna (Câncer)?" [completed]="dpsForm.get('questionAnswer5')?.valid">
                    <div class="row">
                        <!-- Questão 5 -->
                        <div class="col-12  d-flex">
                            <input type="radio" id="cancer_nao"
                            value="não"
                            formControlName="questionAnswer5"
                            class="me-2"
                            >
                            <label for="cancer_nao" class="mb-0 p-1">Não</label>
                        </div>
                        <div class="col-12  d-flex">
                            <input type="radio" id="cancer_sim_menos"
                                value="Sim, com tratamento concluído há menos de 5 anos ou em tratamento"
                                formControlName="questionAnswer5"
                                class="me-2"
                                >
                            <label for="cancer_sim_menos" class="mb-0 p-1">
                                Sim, com tratamento concluído há menos de 5 anos ou em tratamento
                            </label>
                        </div>
                        <div class="col-12 d-flex">
                            <input type="radio" id="cancer_sim_mais"
                                value="Sim, tratamento concluído há mais de 5 anos"
                                formControlName="questionAnswer5"
                                class="me-2"
                            >
                            <label for="cancer_sim_mais" class="mb-0 p-1">
                                Sim, tratamento concluído há mais de 5 anos
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                        </div>
                    </div>

                  </mat-step>

                  <mat-step label="6ª Pergunta: Nos últimos 5 anos, você foi diagnosticado ou tratado clinicamente para:" [completed]="dpsForm.get('questionAnswer6')?.valid">
                    <div class="row">
                      <div class="col-12 d-flex" *ngFor="let option of questionAnswer6List">
                        <!-- Questão 6 -->
                        <mat-checkbox class="mb-0 p-1"
                        (change)="onCheckboxChange('questionAnswer6', option, $event)"
                            [checked]="dpsForm.get('questionAnswer6')?.value?.includes(option)">
                            {{ option }}
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <button mat-flat-button class="btn-brand" matStepperNext>Próximo</button>
                        </div>
                    </div>

                  </mat-step>

                  <mat-step label="7ª Pergunta: Você tem alguma outra doença de caráter crônico que necessite de acompanhamento médico continuado?" [completed]="dpsForm.get('questionAnswer7')?.valid && finalizado == true">
                    <div class="row">
                        <div class="col-12 d-flex">
                            <!-- Questão 7 -->
                            <input type="radio" id="cronico_nao"  value="não" formControlName="questionAnswer7" class="me-2">
                            <label for="cronico_nao" class="mb-0 p-1">Não</label>
                        </div>
                        <div class="col-12 d-flex">
                            <input type="radio" id="cronico_sim"  value="sim" formControlName="questionAnswer7" class="me-2">
                            <label for="cronico_sim" class="mb-0 p-1">Sim</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <button mat-flat-button class="btn-brand submit-button" (click)="onSubmit()" [disabled]="dpsForm.invalid || isButtonDisabled">Enviar</button>
                        </div>
                    </div>
                  </mat-step>

                </form>
              </mat-stepper>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

</div>

<div class="loader" *ngIf="showLoader">
  <div class="content-loader">
    <mat-spinner></mat-spinner>
  </div>
</div>
